import { jsx as _jsx } from "react/jsx-runtime";
import { useHead } from "@/hooks";
import { HeadInfosShell } from "@seo/head-infos";
import { useClassifiedId, useHeadInfo } from "@/contexts/classified";
import { useFeaturesEnabled } from "@/contexts/cdpConfig";
export const Head = () => {
    var _a, _b;
    // Load external scripts and styles
    useHead();
    const { appleItuneApp } = useFeaturesEnabled();
    const metas = [
        {
            // Prevent iOS from detecting telephone numbers
            name: "format-detection",
            content: "telephone=no",
        },
    ];
    // add meta tag for if appleItuneApp is enabled ( currenltly only for seloger)
    if (appleItuneApp) {
        metas.push({
            name: "apple-itunes-app",
            content: "app-id=326883014, app-clip-bundle-id=com.mstv.seloger.appstore.Clip",
        });
    }
    const headInfosProps = {
        title: useClassifiedId(),
        description: "",
        metas,
        ...useHeadInfo(),
        // this is a hack to preload script on SSR
        // because we can't use useHead() on SSR
        // and we need to preload gpt.js for ads
        // headInfosSHell don't have a link props so it is put in icons
        icons: [
            {
                relation: "preload",
                link: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
            },
            ...((_b = (_a = useHeadInfo()) === null || _a === void 0 ? void 0 : _a.icons) !== null && _b !== void 0 ? _b : []),
        ],
    };
    return _jsx(HeadInfosShell, { ...headInfosProps });
};
